__turbopack_context__.v({
  "button": "Button-module-scss-module__VsacPa__button",
  "disabled": "Button-module-scss-module__VsacPa__disabled",
  "is-destructive": "Button-module-scss-module__VsacPa__is-destructive",
  "is-secondary": "Button-module-scss-module__VsacPa__is-secondary",
});
